import { Component,
         Input,
         EventEmitter
       } from '@angular/core';

import * as moment from 'moment';

@Component({
    selector: 'merch-list',
    template: require('./merchlist.html'),
    styles: [require('./merchlist.scss'),
                require('../styles/main.scss')],
    outputs: ['qtyTrigger']
})
export class MerchListComponent {
  @Input() all_merch: any[]=[];
  public qtyTrigger = new EventEmitter();

  // Globally defined purchase limit, to prevent the lists from going on forever.
  purchase_limit: number=50;

  loading: boolean=false;

  constructor() {}

  chgQty(idx: string, merch_qty: any) {
    this.qtyTrigger.emit({idx: idx, qty: merch_qty})
  }

  // Gets how many items can be purchased per order
  getQtyList(merch) {
    var limit = merch['limit_per_order'];
    var qty = merch['qty_avail'];
    var qty_remaining = merch['qty_remaining'];

    // If limit is not set, then default to infinity
    if(limit === '') {
      limit = Infinity;
    }
    else {
      limit = parseInt(limit);
    }

    // If qty is not set, then default to infinity
    if(qty === '') {
      qty = Infinity;
    }
    else {
      qty = qty_remaining;
    }

    var qty_list = [];
    // Then build a list, and continue until i is greater than/equal to limit or qty or purchase_limit
    for(var i = 0; i <= limit && i <= qty && i <= this.purchase_limit; i++) {
      qty_list.push(i.toString());
    }

    return qty_list;
  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/merchlist/merchlist.ts